// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9a9e061c","239":"ce4a2ef0","453":"9e827aca","455":"d6b1a867"}[chunkId] + ".chunk.js";
};